import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import { Card, Collapse, Form } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPhone } from '@fortawesome/pro-solid-svg-icons';

export default function MarketingPreferences({ value, onChange, required, showError }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleAll = (e) => {
    if (e.target.checked) {
      onChange(['email', 'sms', 'phone']);
    } else {
      onChange([]);
    }
  };

  const handlePreferenceChange = (pref, checked) => {
    if (checked) {
      onChange([...value, pref]);
    } else {
      onChange(value.filter(p => p !== pref));
    }
  };

  const hasError = showError && required && value.length === 0;

  return (
    <Form.Group className="mb-4">
      <Form.Label>
        Marketing Preferences
        {required && <span className="text-danger"> *</span>}
      </Form.Label>
      <Card className={hasError ? 'border-danger' : ''}>
        <Card.Header className="py-2 px-3 bg-white d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Form.Check
              checked={value.length === 3}
              className="me-2"
              id="marketing_comm_toggle"
              ref={(el) => {
                if (el) el.indeterminate = value.length > 0 && value.length < 3;
              }}
              onChange={handleToggleAll}
            />
            <label className="mb-0 d-flex align-items-center fw-bold" htmlFor="marketing_comm_toggle">
              <FontAwesomeIcon className="me-2 text-primary" icon={faPhone}/>
              Marketing Communications
            </label>
          </div>
          <Button
            aria-controls="marketingPreferencesCollapse"
            aria-expanded={isOpen}
            className="p-0 text-body"
            icon={faChevronDown}
            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
            variant="ghost"
            onClick={() => setIsOpen(!isOpen)}
          />
        </Card.Header>
        <Collapse in={isOpen}>
          <div id="marketingPreferencesCollapse">
            <Card.Body>
              <Form.Check
                checked={value.includes('email')}
                className="mb-2"
                id="marketing_pref_email"
                label="I consent to receive marketing and promotional communications by email"
                onChange={e => handlePreferenceChange('email', e.target.checked)}
              />
              <Form.Check
                checked={value.includes('sms')}
                className="mb-2"
                id="marketing_pref_sms"
                label="I consent to receive marketing and promotional communications by text message (SMS)"
                onChange={e => handlePreferenceChange('sms', e.target.checked)}
              />
              <Form.Check
                checked={value.includes('phone')}
                id="marketing_pref_phone"
                label="I consent to receive marketing and promotional communications by phone call"
                onChange={e => handlePreferenceChange('phone', e.target.checked)}
              />
            </Card.Body>
          </div>
        </Collapse>
      </Card>
      {hasError && (
        <Form.Text className="text-danger">
          Please select at least one marketing preference
        </Form.Text>
      )}
    </Form.Group>
  );
}

MarketingPreferences.propTypes = {
  required: PropTypes.bool,
  showError: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};

MarketingPreferences.defaultProps = {
  required: false,
  showError: false
};
